import api from "../api";
import { iniciarRequisicao } from '../../helpers/index';

class TempoCoberturaPorSegmentos {
  async getListaFull(headers) {
    const response = await api.get("/compras/tempo-cobertura-curvas-segmentos", { headers });
    return response;
  }

  async deleteMultiplos(headers, params) {
    const response = await api({
      method: 'delete',
      url: `/compras-delete-multiplos-tempo-cobertura-segmentos`,
      headers,
      data: params
    });
    return response;
  }

  async excluirCoberturaPorFilialSegmento(headers, params) {
    return await api({
      method: 'delete',
      url: 'compras/cobertura-por-excecao/segmentos/filiais',
      headers,
      data: params
    });
  }

  async store(headers, params) {
    const response = await api({
      method: 'post',
      url: 'compras/tempo-cobertura-curvas-segmentos',
      headers,
      data: params
    });
    return response;
  }

  async aplicarTempoCobertura(params) {
    const headers = iniciarRequisicao();

    const response = await api({
      method: 'post',
      url: '/compras/tempo-cobertura-curvas-segmentos/aplica-em-produtos',
      headers,
      data: params
    });
    return response;
  }
}

export default new TempoCoberturaPorSegmentos();
